"use strict";
exports.__esModule = true;
exports.LiqERC721Meta__factory = void 0;
var tslib_1 = require("tslib");
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "tokenName",
                type: "string"
            },
            {
                internalType: "string",
                name: "tokenSymbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "_trustedForwarder",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            },
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address"
            },
        ],
        name: "Paused",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address"
            },
        ],
        name: "Unpaused",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getTrustedForwarder",
        outputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            },
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "string",
                name: "uri",
                type: "string"
            },
        ],
        name: "safeMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_trustedForwarder",
                type: "address"
            },
        ],
        name: "setTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "0x60806040523480156200001157600080fd5b5060405162003d7338038062003d73833981810160405281019062000037919062000467565b828281600190816200004a91906200074c565b5080600290816200005c91906200074c565b5050506000600860006101000a81548160ff0219169083151502179055506200009a6200008e620000b460201b60201c565b620000cb60201b60201c565b620000ab816200019160201b60201c565b50505062000833565b6000620000c6620001d460201b60201c565b905090565b6000600860019054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905081600860016101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555050565b60006014600036905010158015620001f95750620001f8336200021660201b60201c565b5b156200020f57601436033560601c905062000213565b3390505b90565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff16149050919050565b6000604051905090565b600080fd5b600080fd5b600080fd5b600080fd5b6000601f19601f8301169050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b620002d8826200028d565b810181811067ffffffffffffffff82111715620002fa57620002f96200029e565b5b80604052505050565b60006200030f6200026f565b90506200031d8282620002cd565b919050565b600067ffffffffffffffff82111562000340576200033f6200029e565b5b6200034b826200028d565b9050602081019050919050565b60005b83811015620003785780820151818401526020810190506200035b565b60008484015250505050565b60006200039b620003958462000322565b62000303565b905082815260208101848484011115620003ba57620003b962000288565b5b620003c784828562000358565b509392505050565b600082601f830112620003e757620003e662000283565b5b8151620003f984826020860162000384565b91505092915050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006200042f8262000402565b9050919050565b620004418162000422565b81146200044d57600080fd5b50565b600081519050620004618162000436565b92915050565b60008060006060848603121562000483576200048262000279565b5b600084015167ffffffffffffffff811115620004a457620004a36200027e565b5b620004b286828701620003cf565b935050602084015167ffffffffffffffff811115620004d657620004d56200027e565b5b620004e486828701620003cf565b9250506040620004f78682870162000450565b9150509250925092565b600081519050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b600060028204905060018216806200055457607f821691505b6020821081036200056a57620005696200050c565b5b50919050565b60008190508160005260206000209050919050565b60006020601f8301049050919050565b600082821b905092915050565b600060088302620005d47fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8262000595565b620005e0868362000595565b95508019841693508086168417925050509392505050565b6000819050919050565b6000819050919050565b60006200062d620006276200062184620005f8565b62000602565b620005f8565b9050919050565b6000819050919050565b62000649836200060c565b62000661620006588262000634565b848454620005a2565b825550505050565b600090565b6200067862000669565b620006858184846200063e565b505050565b5b81811015620006ad57620006a16000826200066e565b6001810190506200068b565b5050565b601f821115620006fc57620006c68162000570565b620006d18462000585565b81016020851015620006e1578190505b620006f9620006f08562000585565b8301826200068a565b50505b505050565b600082821c905092915050565b6000620007216000198460080262000701565b1980831691505092915050565b60006200073c83836200070e565b9150826002028217905092915050565b620007578262000501565b67ffffffffffffffff8111156200077357620007726200029e565b5b6200077f82546200053b565b6200078c828285620006b1565b600060209050601f831160018114620007c45760008415620007af578287015190505b620007bb85826200072e565b8655506200082b565b601f198416620007d48662000570565b60005b82811015620007fe57848901518255600182019150602085019450602081019050620007d7565b868310156200081e57848901516200081a601f8916826200070e565b8355505b6001600288020188555050505b505050505050565b61353080620008436000396000f3fe608060405234801561001057600080fd5b50600436106101585760003560e01c8063715018a6116100c3578063c87b56dd1161007c578063c87b56dd1461038b578063ce1b815f146103bb578063d204c45e146103d9578063da742228146103f5578063e985e9c514610411578063f2fde38b1461044157610158565b8063715018a6146103035780638456cb591461030d5780638da5cb5b1461031757806395d89b4114610335578063a22cb46514610353578063b88d4fde1461036f57610158565b806342842e0e1161011557806342842e0e1461021d57806342966c6814610239578063572b6c05146102555780635c975abb146102855780636352211e146102a357806370a08231146102d357610158565b806301ffc9a71461015d57806306fdde031461018d578063081812fc146101ab578063095ea7b3146101db57806323b872dd146101f75780633f4ba83a14610213575b600080fd5b61017760048036038101906101729190612249565b61045d565b6040516101849190612291565b60405180910390f35b61019561053f565b6040516101a2919061233c565b60405180910390f35b6101c560048036038101906101c09190612394565b6105d1565b6040516101d29190612402565b60405180910390f35b6101f560048036038101906101f09190612449565b610617565b005b610211600480360381019061020c9190612489565b61072e565b005b61021b61078e565b005b61023760048036038101906102329190612489565b6107a0565b005b610253600480360381019061024e9190612394565b6107c0565b005b61026f600480360381019061026a91906124dc565b61081c565b60405161027c9190612291565b60405180910390f35b61028d610875565b60405161029a9190612291565b60405180910390f35b6102bd60048036038101906102b89190612394565b61088c565b6040516102ca9190612402565b60405180910390f35b6102ed60048036038101906102e891906124dc565b610912565b6040516102fa9190612518565b60405180910390f35b61030b6109c9565b005b6103156109dd565b005b61031f6109ef565b60405161032c9190612402565b60405180910390f35b61033d610a19565b60405161034a919061233c565b60405180910390f35b61036d6004803603810190610368919061255f565b610aab565b005b610389600480360381019061038491906126d4565b610ac1565b005b6103a560048036038101906103a09190612394565b610b23565b6040516103b2919061233c565b60405180910390f35b6103c3610b35565b6040516103d09190612402565b60405180910390f35b6103f360048036038101906103ee91906127f8565b610b5e565b005b61040f600480360381019061040a91906124dc565b610b97565b005b61042b60048036038101906104269190612854565b610bab565b6040516104389190612291565b60405180910390f35b61045b600480360381019061045691906124dc565b610c3f565b005b60007f80ac58cd000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916148061052857507f5b5e139f000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916145b80610538575061053782610cc2565b5b9050919050565b60606001805461054e906128c3565b80601f016020809104026020016040519081016040528092919081815260200182805461057a906128c3565b80156105c75780601f1061059c576101008083540402835291602001916105c7565b820191906000526020600020905b8154815290600101906020018083116105aa57829003601f168201915b5050505050905090565b60006105dc82610d2c565b6005600083815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050919050565b60006106228261088c565b90508073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff1603610692576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161068990612966565b60405180910390fd5b8073ffffffffffffffffffffffffffffffffffffffff166106b1610d77565b73ffffffffffffffffffffffffffffffffffffffff1614806106e057506106df816106da610d77565b610bab565b5b61071f576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610716906129f8565b60405180910390fd5b6107298383610d86565b505050565b61073f610739610d77565b82610e3f565b61077e576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161077590612a8a565b60405180910390fd5b610789838383610ed4565b505050565b6107966111cd565b61079e61124b565b565b6107bb83838360405180602001604052806000815250610ac1565b505050565b6107d16107cb610d77565b82610e3f565b610810576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161080790612a8a565b60405180910390fd5b610819816112ae565b50565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff16149050919050565b6000600860009054906101000a900460ff16905090565b600080610898836112ba565b9050600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603610909576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161090090612af6565b60405180910390fd5b80915050919050565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1603610982576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161097990612b88565b60405180910390fd5b600460008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020549050919050565b6109d16111cd565b6109db60006112f7565b565b6109e56111cd565b6109ed6113bd565b565b6000600860019054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905090565b606060028054610a28906128c3565b80601f0160208091040260200160405190810160405280929190818152602001828054610a54906128c3565b8015610aa15780601f10610a7657610100808354040283529160200191610aa1565b820191906000526020600020905b815481529060010190602001808311610a8457829003601f168201915b5050505050905090565b610abd610ab6610d77565b8383611420565b5050565b610ad2610acc610d77565b83610e3f565b610b11576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610b0890612a8a565b60405180910390fd5b610b1d8484848461158c565b50505050565b6060610b2e826115e8565b9050919050565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905090565b610b666111cd565b6000610b7260096116fa565b9050610b7e6009611708565b610b88838261171e565b610b92818361173c565b505050565b610b9f6111cd565b610ba8816117a9565b50565b6000600660008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b610c476111cd565b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603610cb6576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610cad90612c1a565b60405180910390fd5b610cbf816112f7565b50565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149050919050565b610d35816117ec565b610d74576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d6b90612af6565b60405180910390fd5b50565b6000610d8161182d565b905090565b816005600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff16610df98361088c565b73ffffffffffffffffffffffffffffffffffffffff167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b600080610e4b8361088c565b90508073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff161480610e8d5750610e8c8185610bab565b5b80610ecb57508373ffffffffffffffffffffffffffffffffffffffff16610eb3846105d1565b73ffffffffffffffffffffffffffffffffffffffff16145b91505092915050565b8273ffffffffffffffffffffffffffffffffffffffff16610ef48261088c565b73ffffffffffffffffffffffffffffffffffffffff1614610f4a576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f4190612cac565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1603610fb9576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610fb090612d3e565b60405180910390fd5b610fc68383836001611864565b8273ffffffffffffffffffffffffffffffffffffffff16610fe68261088c565b73ffffffffffffffffffffffffffffffffffffffff161461103c576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161103390612cac565b60405180910390fd5b6005600082815260200190815260200160002060006101000a81549073ffffffffffffffffffffffffffffffffffffffff02191690556001600460008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825403925050819055506001600460008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008282540192505081905550816003600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a46111c8838383600161187e565b505050565b6111d5610d77565b73ffffffffffffffffffffffffffffffffffffffff166111f36109ef565b73ffffffffffffffffffffffffffffffffffffffff1614611249576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161124090612daa565b60405180910390fd5b565b611253611884565b6000600860006101000a81548160ff0219169083151502179055507f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa611297610d77565b6040516112a49190612402565b60405180910390a1565b6112b7816118cd565b50565b60006003600083815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050919050565b6000600860019054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905081600860016101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b6113c5611920565b6001600860006101000a81548160ff0219169083151502179055507f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258611409610d77565b6040516114169190612402565b60405180910390a1565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff160361148e576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161148590612e16565b60405180910390fd5b80600660008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c318360405161157f9190612291565b60405180910390a3505050565b611597848484610ed4565b6115a38484848461196a565b6115e2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016115d990612ea8565b60405180910390fd5b50505050565b60606115f382610d2c565b6000600760008481526020019081526020016000208054611613906128c3565b80601f016020809104026020016040519081016040528092919081815260200182805461163f906128c3565b801561168c5780601f106116615761010080835404028352916020019161168c565b820191906000526020600020905b81548152906001019060200180831161166f57829003601f168201915b50505050509050600061169d611af1565b905060008151036116b25781925050506116f5565b6000825111156116e75780826040516020016116cf929190612f04565b604051602081830303815290604052925050506116f5565b6116f084611b08565b925050505b919050565b600081600001549050919050565b6001816000016000828254019250508190555050565b611738828260405180602001604052806000815250611b70565b5050565b611745826117ec565b611784576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161177b90612f9a565b60405180910390fd5b806007600084815260200190815260200160002090816117a49190613166565b505050565b806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555050565b60008073ffffffffffffffffffffffffffffffffffffffff1661180e836112ba565b73ffffffffffffffffffffffffffffffffffffffff1614159050919050565b6000601460003690501015801561184957506118483361081c565b5b1561185d57601436033560601c9050611861565b3390505b90565b61186c611920565b61187884848484611bcb565b50505050565b50505050565b61188c610875565b6118cb576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016118c290613284565b60405180910390fd5b565b6118d681611bd1565b60006007600083815260200190815260200160002080546118f6906128c3565b90501461191d5760076000828152602001908152602001600020600061191c9190612180565b5b50565b611928610875565b15611968576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161195f906132f0565b60405180910390fd5b565b600061198b8473ffffffffffffffffffffffffffffffffffffffff16611d1f565b15611ae4578373ffffffffffffffffffffffffffffffffffffffff1663150b7a026119b4610d77565b8786866040518563ffffffff1660e01b81526004016119d69493929190613365565b6020604051808303816000875af1925050508015611a1257506040513d601f19601f82011682018060405250810190611a0f91906133c6565b60015b611a94573d8060008114611a42576040519150601f19603f3d011682016040523d82523d6000602084013e611a47565b606091505b506000815103611a8c576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611a8390612ea8565b60405180910390fd5b805181602001fd5b63150b7a0260e01b7bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916817bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191614915050611ae9565b600190505b949350505050565b606060405180602001604052806000815250905090565b6060611b1382610d2c565b6000611b1d611af1565b90506000815111611b3d5760405180602001604052806000815250611b68565b80611b4784611d42565b604051602001611b58929190612f04565b6040516020818303038152906040525b915050919050565b611b7a8383611e10565b611b87600084848461196a565b611bc6576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611bbd90612ea8565b60405180910390fd5b505050565b50505050565b6000611bdc8261088c565b9050611bec816000846001611864565b611bf58261088c565b90506005600083815260200190815260200160002060006101000a81549073ffffffffffffffffffffffffffffffffffffffff02191690556001600460008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825403925050819055506003600083815260200190815260200160002060006101000a81549073ffffffffffffffffffffffffffffffffffffffff021916905581600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a4611d1b81600084600161187e565b5050565b6000808273ffffffffffffffffffffffffffffffffffffffff163b119050919050565b606060006001611d518461202d565b01905060008167ffffffffffffffff811115611d7057611d6f6125a9565b5b6040519080825280601f01601f191660200182016040528015611da25781602001600182028036833780820191505090505b509050600082602001820190505b600115611e05578080600190039150507f3031323334353637383961626364656600000000000000000000000000000000600a86061a8153600a8581611df957611df86133f3565b5b04945060008503611db0575b819350505050919050565b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1603611e7f576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611e769061346e565b60405180910390fd5b611e88816117ec565b15611ec8576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611ebf906134da565b60405180910390fd5b611ed6600083836001611864565b611edf816117ec565b15611f1f576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611f16906134da565b60405180910390fd5b6001600460008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008282540192505081905550816003600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff16600073ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a461202960008383600161187e565b5050565b600080600090507a184f03e93ff9f4daa797ed6e38ed64bf6a1f010000000000000000831061208b577a184f03e93ff9f4daa797ed6e38ed64bf6a1f0100000000000000008381612081576120806133f3565b5b0492506040810190505b6d04ee2d6d415b85acef810000000083106120c8576d04ee2d6d415b85acef810000000083816120be576120bd6133f3565b5b0492506020810190505b662386f26fc1000083106120f757662386f26fc1000083816120ed576120ec6133f3565b5b0492506010810190505b6305f5e1008310612120576305f5e1008381612116576121156133f3565b5b0492506008810190505b612710831061214557612710838161213b5761213a6133f3565b5b0492506004810190505b60648310612168576064838161215e5761215d6133f3565b5b0492506002810190505b600a8310612177576001810190505b80915050919050565b50805461218c906128c3565b6000825580601f1061219e57506121bd565b601f0160209004906000526020600020908101906121bc91906121c0565b5b50565b5b808211156121d95760008160009055506001016121c1565b5090565b6000604051905090565b600080fd5b600080fd5b60007fffffffff0000000000000000000000000000000000000000000000000000000082169050919050565b612226816121f1565b811461223157600080fd5b50565b6000813590506122438161221d565b92915050565b60006020828403121561225f5761225e6121e7565b5b600061226d84828501612234565b91505092915050565b60008115159050919050565b61228b81612276565b82525050565b60006020820190506122a66000830184612282565b92915050565b600081519050919050565b600082825260208201905092915050565b60005b838110156122e65780820151818401526020810190506122cb565b60008484015250505050565b6000601f19601f8301169050919050565b600061230e826122ac565b61231881856122b7565b93506123288185602086016122c8565b612331816122f2565b840191505092915050565b600060208201905081810360008301526123568184612303565b905092915050565b6000819050919050565b6123718161235e565b811461237c57600080fd5b50565b60008135905061238e81612368565b92915050565b6000602082840312156123aa576123a96121e7565b5b60006123b88482850161237f565b91505092915050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006123ec826123c1565b9050919050565b6123fc816123e1565b82525050565b600060208201905061241760008301846123f3565b92915050565b612426816123e1565b811461243157600080fd5b50565b6000813590506124438161241d565b92915050565b600080604083850312156124605761245f6121e7565b5b600061246e85828601612434565b925050602061247f8582860161237f565b9150509250929050565b6000806000606084860312156124a2576124a16121e7565b5b60006124b086828701612434565b93505060206124c186828701612434565b92505060406124d28682870161237f565b9150509250925092565b6000602082840312156124f2576124f16121e7565b5b600061250084828501612434565b91505092915050565b6125128161235e565b82525050565b600060208201905061252d6000830184612509565b92915050565b61253c81612276565b811461254757600080fd5b50565b60008135905061255981612533565b92915050565b60008060408385031215612576576125756121e7565b5b600061258485828601612434565b92505060206125958582860161254a565b9150509250929050565b600080fd5b600080fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6125e1826122f2565b810181811067ffffffffffffffff82111715612600576125ff6125a9565b5b80604052505050565b60006126136121dd565b905061261f82826125d8565b919050565b600067ffffffffffffffff82111561263f5761263e6125a9565b5b612648826122f2565b9050602081019050919050565b82818337600083830152505050565b600061267761267284612624565b612609565b905082815260208101848484011115612693576126926125a4565b5b61269e848285612655565b509392505050565b600082601f8301126126bb576126ba61259f565b5b81356126cb848260208601612664565b91505092915050565b600080600080608085870312156126ee576126ed6121e7565b5b60006126fc87828801612434565b945050602061270d87828801612434565b935050604061271e8782880161237f565b925050606085013567ffffffffffffffff81111561273f5761273e6121ec565b5b61274b878288016126a6565b91505092959194509250565b600067ffffffffffffffff821115612772576127716125a9565b5b61277b826122f2565b9050602081019050919050565b600061279b61279684612757565b612609565b9050828152602081018484840111156127b7576127b66125a4565b5b6127c2848285612655565b509392505050565b600082601f8301126127df576127de61259f565b5b81356127ef848260208601612788565b91505092915050565b6000806040838503121561280f5761280e6121e7565b5b600061281d85828601612434565b925050602083013567ffffffffffffffff81111561283e5761283d6121ec565b5b61284a858286016127ca565b9150509250929050565b6000806040838503121561286b5761286a6121e7565b5b600061287985828601612434565b925050602061288a85828601612434565b9150509250929050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b600060028204905060018216806128db57607f821691505b6020821081036128ee576128ed612894565b5b50919050565b7f4552433732313a20617070726f76616c20746f2063757272656e74206f776e6560008201527f7200000000000000000000000000000000000000000000000000000000000000602082015250565b60006129506021836122b7565b915061295b826128f4565b604082019050919050565b6000602082019050818103600083015261297f81612943565b9050919050565b7f4552433732313a20617070726f76652063616c6c6572206973206e6f7420746f60008201527f6b656e206f776e6572206f7220617070726f76656420666f7220616c6c000000602082015250565b60006129e2603d836122b7565b91506129ed82612986565b604082019050919050565b60006020820190508181036000830152612a11816129d5565b9050919050565b7f4552433732313a2063616c6c6572206973206e6f7420746f6b656e206f776e6560008201527f72206f7220617070726f76656400000000000000000000000000000000000000602082015250565b6000612a74602d836122b7565b9150612a7f82612a18565b604082019050919050565b60006020820190508181036000830152612aa381612a67565b9050919050565b7f4552433732313a20696e76616c696420746f6b656e2049440000000000000000600082015250565b6000612ae06018836122b7565b9150612aeb82612aaa565b602082019050919050565b60006020820190508181036000830152612b0f81612ad3565b9050919050565b7f4552433732313a2061646472657373207a65726f206973206e6f74206120766160008201527f6c6964206f776e65720000000000000000000000000000000000000000000000602082015250565b6000612b726029836122b7565b9150612b7d82612b16565b604082019050919050565b60006020820190508181036000830152612ba181612b65565b9050919050565b7f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160008201527f6464726573730000000000000000000000000000000000000000000000000000602082015250565b6000612c046026836122b7565b9150612c0f82612ba8565b604082019050919050565b60006020820190508181036000830152612c3381612bf7565b9050919050565b7f4552433732313a207472616e736665722066726f6d20696e636f72726563742060008201527f6f776e6572000000000000000000000000000000000000000000000000000000602082015250565b6000612c966025836122b7565b9150612ca182612c3a565b604082019050919050565b60006020820190508181036000830152612cc581612c89565b9050919050565b7f4552433732313a207472616e7366657220746f20746865207a65726f2061646460008201527f7265737300000000000000000000000000000000000000000000000000000000602082015250565b6000612d286024836122b7565b9150612d3382612ccc565b604082019050919050565b60006020820190508181036000830152612d5781612d1b565b9050919050565b7f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572600082015250565b6000612d946020836122b7565b9150612d9f82612d5e565b602082019050919050565b60006020820190508181036000830152612dc381612d87565b9050919050565b7f4552433732313a20617070726f766520746f2063616c6c657200000000000000600082015250565b6000612e006019836122b7565b9150612e0b82612dca565b602082019050919050565b60006020820190508181036000830152612e2f81612df3565b9050919050565b7f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560008201527f63656976657220696d706c656d656e7465720000000000000000000000000000602082015250565b6000612e926032836122b7565b9150612e9d82612e36565b604082019050919050565b60006020820190508181036000830152612ec181612e85565b9050919050565b600081905092915050565b6000612ede826122ac565b612ee88185612ec8565b9350612ef88185602086016122c8565b80840191505092915050565b6000612f108285612ed3565b9150612f1c8284612ed3565b91508190509392505050565b7f45524337323155524953746f726167653a2055524920736574206f66206e6f6e60008201527f6578697374656e7420746f6b656e000000000000000000000000000000000000602082015250565b6000612f84602e836122b7565b9150612f8f82612f28565b604082019050919050565b60006020820190508181036000830152612fb381612f77565b9050919050565b60008190508160005260206000209050919050565b60006020601f8301049050919050565b600082821b905092915050565b60006008830261301c7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff82612fdf565b6130268683612fdf565b95508019841693508086168417925050509392505050565b6000819050919050565b600061306361305e6130598461235e565b61303e565b61235e565b9050919050565b6000819050919050565b61307d83613048565b6130916130898261306a565b848454612fec565b825550505050565b600090565b6130a6613099565b6130b1818484613074565b505050565b5b818110156130d5576130ca60008261309e565b6001810190506130b7565b5050565b601f82111561311a576130eb81612fba565b6130f484612fcf565b81016020851015613103578190505b61311761310f85612fcf565b8301826130b6565b50505b505050565b600082821c905092915050565b600061313d6000198460080261311f565b1980831691505092915050565b6000613156838361312c565b9150826002028217905092915050565b61316f826122ac565b67ffffffffffffffff811115613188576131876125a9565b5b61319282546128c3565b61319d8282856130d9565b600060209050601f8311600181146131d057600084156131be578287015190505b6131c8858261314a565b865550613230565b601f1984166131de86612fba565b60005b82811015613206578489015182556001820191506020850194506020810190506131e1565b86831015613223578489015161321f601f89168261312c565b8355505b6001600288020188555050505b505050505050565b7f5061757361626c653a206e6f7420706175736564000000000000000000000000600082015250565b600061326e6014836122b7565b915061327982613238565b602082019050919050565b6000602082019050818103600083015261329d81613261565b9050919050565b7f5061757361626c653a2070617573656400000000000000000000000000000000600082015250565b60006132da6010836122b7565b91506132e5826132a4565b602082019050919050565b60006020820190508181036000830152613309816132cd565b9050919050565b600081519050919050565b600082825260208201905092915050565b600061333782613310565b613341818561331b565b93506133518185602086016122c8565b61335a816122f2565b840191505092915050565b600060808201905061337a60008301876123f3565b61338760208301866123f3565b6133946040830185612509565b81810360608301526133a6818461332c565b905095945050505050565b6000815190506133c08161221d565b92915050565b6000602082840312156133dc576133db6121e7565b5b60006133ea848285016133b1565b91505092915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b7f4552433732313a206d696e7420746f20746865207a65726f2061646472657373600082015250565b60006134586020836122b7565b915061346382613422565b602082019050919050565b600060208201905081810360008301526134878161344b565b9050919050565b7f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000600082015250565b60006134c4601c836122b7565b91506134cf8261348e565b602082019050919050565b600060208201905081810360008301526134f3816134b7565b905091905056fea2646970667358221220a84598f1a3b9b97191d2335e2c480487bbf3d401f5e66fe2f9265269056ccead64736f6c63430008130033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var LiqERC721Meta__factory = /** @class */ (function (_super) {
    tslib_1.__extends(LiqERC721Meta__factory, _super);
    function LiqERC721Meta__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    LiqERC721Meta__factory.prototype.deploy = function (tokenName, tokenSymbol, _trustedForwarder, overrides) {
        return _super.prototype.deploy.call(this, tokenName, tokenSymbol, _trustedForwarder, overrides || {});
    };
    LiqERC721Meta__factory.prototype.getDeployTransaction = function (tokenName, tokenSymbol, _trustedForwarder, overrides) {
        return _super.prototype.getDeployTransaction.call(this, tokenName, tokenSymbol, _trustedForwarder, overrides || {});
    };
    LiqERC721Meta__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    LiqERC721Meta__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    LiqERC721Meta__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    LiqERC721Meta__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    LiqERC721Meta__factory.bytecode = _bytecode;
    LiqERC721Meta__factory.abi = _abi;
    return LiqERC721Meta__factory;
}(ethers_1.ContractFactory));
exports.LiqERC721Meta__factory = LiqERC721Meta__factory;
